import { ActivityLogParser } from '@/parsers/activityLog'
import { i18n } from '@/i18n'

export class ContractNumberActivityLogParser extends ActivityLogParser {
    static showLogDetailsCreated = true

    static getLogDetailsDeleted (activityLog, data) {
        return [
            {
                key: 'number',
                label: i18n.tc('forms.field.label.contract-number.number', 1),
                oldValue: activityLog.properties?.old?.number,
            },
        ]
    }
}
